import React from "react";
import { SECCIONES } from "../ipcFormat";

/**
 * Sections of the queue as pill tabs with the count of active gestiones (design Prompt 1): Todas, Modificación,
 * Reclamo, Consulta and Proactiva. Arrow keys move between them; the count shows once the server sent it.
 */
export default function SectionTabs({ value, counts, onChange }) {
  const handleKeyDown = (event) => {
    if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;
    event.preventDefault();
    const index = SECCIONES.findIndex((seccion) => seccion.value === value);
    const step = event.key === "ArrowRight" ? 1 : -1;
    const next = SECCIONES[(index + step + SECCIONES.length) % SECCIONES.length];
    onChange(next.value);
    event.currentTarget.querySelector(`[data-seccion="${next.value}"]`)?.focus();
  };

  return (
    <div className="crm-ipc__sections" role="tablist" aria-label="Secciones" onKeyDown={handleKeyDown}>
      {SECCIONES.map((seccion) => {
        const selected = seccion.value === value;
        const count = counts?.[seccion.value];
        const hasCount = count !== undefined && count !== null;
        return (
          <button
            key={seccion.value}
            type="button"
            role="tab"
            data-seccion={seccion.value}
            aria-selected={selected}
            tabIndex={selected ? 0 : -1}
            className={hasCount ? "crm-ipc__section crm-ipc__section--count" : "crm-ipc__section"}
            onClick={() => onChange(seccion.value)}
          >
            {seccion.label}
            {hasCount ? (
              <span className="crm-ipc__section-n" aria-label={`${count} ${Number(count) === 1 ? "activa" : "activas"}`}>
                {count}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
